import type { Translations } from './types';

export const ko: Translations = {
  app: {
    title: 'Release Gate',
    version: 'release-board v0.2',
  },
  form: {
    basicInfo: '기본 정보',
    featureName: 'feature_name',
    releaseDate: 'release_date',
    planningIntent: '기획 의도',
    planningPlaceholder: '- CS 리포트 요청 감소\n- 리포트 생성 시간 단축',
    onePerLine: '한 줄에 하나씩',
    risks: '릴리즈 리스크',
    risksPlaceholder: '- 네트워크 불안정 시 리포트 생성 실패 가능\n- iOS 15 이하 미검증',
    qaStatus: 'QA 검증 상태',
    coreScenario: 'core_scenario',
    edgeCases: 'edge_cases',
    select: '--선택--',
    passVerified: 'PASS - 검증 완료',
    partialVerified: 'PARTIAL - 일부 검증',
    partialUnverified: 'PARTIAL - 일부 미검증',
    failUnverified: 'FAIL - 미검증',
    evaluating: 'evaluating',
    runEvaluate: '> run evaluate',
    // 파일 업로드
    inputMode: '입력 방식',
    manualInput: '직접 입력',
    fileUpload: '파일 업로드',
    dragDropFile: '📎 파일을 드래그하거나 클릭하세요',
    supportedFormats: '이미지(PNG, JPG), PDF, 텍스트 지원',
    analyzing: '분석 중...',
    extractedItems: 'AI가 추출한 항목',
    testCaseImport: '테스트 케이스 임포트',
    testCaseDragDrop: '📎 테스트 케이스 파일 드래그',
    testCaseSupportedFormats: 'CSV, JSON, Markdown 지원',
    testCaseAnalysis: '분석 결과',
    totalTestCases: '총 테스트 케이스',
    passed: '통과',
    clearFile: '파일 삭제',
    // 템플릿 & 스크린샷
    downloadTemplate: '📥 템플릿 다운로드',
    templateDescription: '아래 형식에 맞춰 테스트 케이스를 작성하세요',
    screenshotUpload: '스크린샷 업로드',
    screenshotDescription: '앱/웹 화면 스크린샷을 업로드하면 AI가 분석합니다',
    screenshotAnalysisItems: 'AI 분석 항목',
    uiComponents: 'UI 구성요소',
    userFlow: '사용자 플로우',
    kpiSuggestions: 'KPI 제안',
    coreTestCases: '핵심 테스트',
    edgeTestCases: '엣지 테스트',
    orDivider: '또는',
    clearAll: '모두 삭제',
    // 이탈 확인
    unsavedChangesTitle: '작성 중인 내용이 있습니다',
    unsavedChangesMessage: '저장되지 않은 변경사항이 있습니다. 정말 나가시겠습니까?',
    unsavedChangesStay: '계속 작성',
    unsavedChangesLeave: '이동하기',
    unsavedChangesDontAskToday: '오늘 하루 묻지 않기',
    // 임시 저장
    draftSaved: '임시 저장됨',
    draftRestoreTitle: '임시 저장된 내용이 있습니다',
    draftRestoreMessage: '이전에 작성하던 내용을 불러올까요?',
    draftRestoreTime: '{time}에 저장됨',
    draftRestore: '불러오기',
    draftDiscard: '새로 시작',
    draftAutoSave: '자동 저장',
  },
  result: {
    reportTitle: 'RELEASE DECISION REPORT',
    feature: 'FEATURE',
    releaseDate: 'RELEASE_DATE',
    inputData: '입력 정보',
    evaluationResult: '평가 결과',
    confidenceScore: 'CONFIDENCE_SCORE',
    status: 'STATUS',
    judgmentBasis: '판정 근거',
    allItemsGood: '기획, 리스크, QA 항목 모두 양호',
    someImprovementNeeded: '일부 항목에서 개선 필요',
    reviewRecommendations: '권고사항 검토 후 출시 결정 필요',
    multipleUnmet: '다수 항목에서 미충족',
    reEvaluationRecommended: '추가 준비 후 재평가 권장',
    blockersToResolve: '블로커 {count}건 해결 필요',
    itemScores: '항목별 점수',
    blockers: '블로커',
    blockersSubtitle: '출시 전 필수 해결',
    recommendations: '권고사항',
    confirmation: '확인',
    author: '작성자',
    approver: '승인자',
    savePdf: '📄 PDF 다운로드',
    generating: '생성 중...',
    newEvaluation: '> new evaluation',
    // 구조화된 권고사항
    actionItems: '액션 아이템',
    deadline: '권장 완료 시점',
    owner: '담당',
    priorityHigh: '높음',
    priorityMedium: '보통',
    priorityLow: '낮음',
    // PDF 다운로드
    pdfDownload: '📄 PDF 리포트 다운로드',
    pdfDownloading: 'PDF 생성 중...',
    pdfProOnly: 'Pro 이상 플랜 전용',
    pdfUpgradeHint: 'Pro 플랜으로 업그레이드하면 PDF 리포트를 다운로드할 수 있습니다.',
    pdfError: 'PDF 생성에 실패했습니다. 다시 시도해주세요.',
    maxAiReport: 'AI 분석 리포트 보기',
    maxUpgradeHint: 'Max 플랜에서는 AI 분석 리포트로 더 깊은 인사이트를 얻을 수 있습니다',
    // 플랫폼 인사이트
    platformInsights: '플랫폼 인사이트',
    platformInsightsSubtitle: '플랫폼별 주요 고려사항',
    keyChanges: '주요 변경 사항',
    alignedPoints: '충족된 점',
    gaps: '확인 필요한 점',
    tips: '알아두면 좋은 팁',
  },
  status: {
    go: 'GO',
    goDesc: '출시 가능',
    conditional: 'CONDITIONAL',
    conditionalDesc: '조건부 출시',
    holding: 'HOLDING',
    holdingDesc: '출시 보류',
    noGo: 'NO-GO',
    noGoDesc: '출시 불가',
  },
  grade: {
    excellent: '우수',
    good: '양호',
    average: '보통',
    poor: '미흡',
    insufficient: '부족',
  },
  qaValue: {
    verified: '검증 완료',
    partiallyVerified: '일부 검증',
    partiallyUnverified: '일부 미검증',
    unverified: '미검증',
    notEntered: '미입력',
    partiallyFailed: '일부 실패',
    failed: '실패',
  },
  footer: {
    tagline: '기획검증 → 리스크검증 → 테스트검증',
    copyright: '© 2025 ReleaseGate. All rights reserved.',
  },
  error: {
    unknown: '알 수 없는 오류',
  },
  language: {
    ko: '한국어',
    en: 'English',
  },
  theme: {
    selector: '테마 선택',
    light: '라이트',
    dark: '다크',
    system: '시스템',
  },
  loadingQuotes: [
    '"품질은 행동이 아니라 습관이다." — 아리스토텔레스',
    '"테스트는 버그의 부재가 아닌, 존재를 보여준다." — 다익스트라',
    '"사용자가 찾기 전에 버그를 찾자. 그것이 우리의 존재 이유다." 🐛',
    '"오늘의 테스트가 내일의 장애를 막는다." 🛡️',
    '"좋은 QA 엔지니어는 개발자의 적이 아닌, 가장 든든한 방패다." 🤝',
    '"버그 없는 코드는 없다. 아직 발견하지 못했을 뿐." 🔍',
    '"커피 한 잔의 여유와 함께, 꼼꼼한 검증을!" ☕',
    '"테스트 케이스는 우리의 무기, 버그 리포트는 훈장." 🎖️',
    '"릴리즈 전 마지막 방어선, 당신은 수호자입니다." 🏰',
    '"완벽한 품질을 위해 오늘도 우리는 클릭한다." 🖱️',
    '"사용자의 미소가 우리의 보람입니다." 😊',
    '"품질은 타협의 대상이 아닙니다." 💪',
    '"버그를 잡는 건 사냥, 예방하는 건 예술이다." 🎨',
    '"한 번의 테스트가 천 번의 CS를 줄인다." 📉',
    '"QA 엔지니어의 꼼꼼함이 서비스의 신뢰를 만든다." ✨',
  ],
  auth: {
    login: '로그인',
    logout: '로그아웃',
    loginWithGoogle: 'Google로 로그인',
    loginWithGithub: 'GitHub로 로그인',
    loginWithEmail: '이메일로 로그인',
    or: '또는',
    quickLoginTitle: '간편하게 로그인',
    quickLoginDesc: '사용할 계정을 선택해주세요.',
    welcomeBack: '다시 오셨군요!',
    profile: '프로필',
    loginRequired: '로그인이 필요합니다',
    loginDescription: 'Google 계정으로 간편하게 로그인하세요.',
    manageSubscription: '구독 관리',
    subscriptionDesc: '결제 정보 변경, 플랜 변경, 구독 취소',
    loggingIn: '로그인 중...',
    // 이메일/비밀번호 인증
    email: '이메일',
    emailPlaceholder: 'example@email.com',
    password: '비밀번호',
    passwordPlaceholder: '비밀번호 입력',
    passwordConfirm: '비밀번호 확인',
    passwordConfirmPlaceholder: '비밀번호 재입력',
    name: '이름',
    namePlaceholder: '이름 입력 (선택)',
    continueWithEmail: '이메일로 계속하기',
    createAccount: '계정 만들기',
    signUp: '회원가입',
    alreadyHaveAccount: '이미 계정이 있으신가요?',
    dontHaveAccount: '계정이 없으신가요?',
    forgotPassword: '비밀번호를 잊으셨나요?',
    resetPassword: '비밀번호 재설정',
    setPassword: '비밀번호 설정',
    changePassword: '비밀번호 변경',
    // OTP 인증
    otpTitle: '이메일 인증',
    otpDescription: '{email}로 발송된 6자리 인증 코드를 입력해주세요.',
    otpPlaceholder: '인증 코드 6자리',
    otpExpireInfo: '인증 코드는 {minutes}분 동안 유효합니다.',
    otpResend: '인증 코드 재발송',
    otpResendCooldown: '{seconds}초 후 재발송 가능',
    otpVerify: '인증하기',
    otpVerifying: '인증 중...',
    // 비밀번호 정책
    passwordPolicy: '비밀번호 조건',
    passwordMinLength: '8자리 이상',
    passwordUppercase: '대문자 포함',
    passwordLowercase: '소문자 포함',
    passwordNumber: '숫자 포함',
    passwordSpecial: '특수문자 포함',
    passwordMatch: '비밀번호 일치',
    // 비밀번호 재설정
    resetPasswordTitle: '비밀번호 재설정',
    resetPasswordDescription: '가입한 이메일을 입력하시면 비밀번호 재설정 링크를 보내드립니다.',
    resetPasswordSent: '비밀번호 재설정 링크가 이메일로 발송되었습니다.',
    resetPasswordSentDescription: '이메일을 확인하고 링크를 클릭하여 비밀번호를 재설정하세요.',
    newPassword: '새 비밀번호',
    newPasswordConfirm: '새 비밀번호 확인',
    resetPasswordComplete: '비밀번호가 재설정되었습니다.',
    // 계정 연결
    accountConnected: '{provider}로 가입된 계정입니다',
    connectPassword: '비밀번호 로그인 추가',
    passwordConnected: '비밀번호가 설정되었습니다',
    // 에러 메시지
    emailRequired: '이메일을 입력해주세요',
    passwordRequired: '비밀번호를 입력해주세요',
    invalidEmail: '올바른 이메일 형식이 아닙니다',
    invalidPassword: '비밀번호 조건을 확인해주세요',
    passwordMismatch: '비밀번호가 일치하지 않습니다',
  },
  coupon: {
    menu: '쿠폰',
    title: '쿠폰',
    subtitle: '쿠폰 코드를 등록하고, 등록된 쿠폰을 사용해 혜택을 적용하세요.',
    codeLabel: '쿠폰 코드',
    codePlaceholder: '예) WELCOME30',
    register: '등록',
    registering: '등록 중...',
    registered: '쿠폰이 등록되었습니다',
    registeredListTitle: '등록된 쿠폰',
    noRegistered: '등록된 쿠폰이 없습니다.',
    use: '사용',
    using: '사용 중...',
    used: '사용 완료',
    apply: '적용',
    applying: '적용 중...',
    applied: '쿠폰이 적용되었습니다',
    applyFailed: '쿠폰 적용에 실패했습니다',
    registerFailed: '쿠폰 등록에 실패했습니다',
    loadFailed: '쿠폰 목록을 불러오지 못했습니다',
    close: '닫기',
    errors: {
      COUPON_CODE_REQUIRED: '쿠폰 코드를 입력해주세요.',
      COUPON_INVALID: '유효하지 않은 쿠폰 코드입니다.',
      COUPON_NOT_REGISTERED: '쿠폰이 등록되어 있지 않습니다. 먼저 등록해주세요.',
      COUPON_ALREADY_USED: '이미 사용한 쿠폰입니다.',
      COUPON_INACTIVE: '비활성화된 쿠폰입니다.',
      COUPON_NOT_STARTED: '아직 사용 기간이 아닙니다.',
      COUPON_EXPIRED: '만료된 쿠폰입니다.',
      COUPON_PLAN_TOO_HIGH: '현재 플랜이 쿠폰 혜택 플랜보다 높아 사용할 수 없습니다.',
      COUPON_PLAN_MISMATCH: '이 쿠폰은 특정 플랜 사용자만 사용할 수 있습니다.',
      COUPON_EXHAUSTED: '이미 소진된 쿠폰입니다.',
      COUPON_BETA_PERIOD: '베타 기간에는 쿠폰을 사용할 수 없습니다.',
      COUPON_PLAN_UNKNOWN: '플랜 정보를 확인할 수 없습니다.',
      USER_NOT_FOUND: '사용자를 찾을 수 없습니다.',
    },
  },
  terms: {
    title: '서비스 이용 동의',
    subtitle: '서비스 이용을 위해 아래 약관에 동의해주세요.',
    termsOfService: '이용약관',
    termsOfServiceRequired: '이용약관 동의 (필수)',
    privacyPolicy: '개인정보처리방침',
    privacyPolicyRequired: '개인정보처리방침 동의 (필수)',
    marketingConsent: '마케팅 정보 수신',
    marketingOptional: '마케팅 정보 수신 동의 (선택)',
    agreeAll: '전체 동의',
    continue: '동의하고 계속하기',
    cancel: '취소',
    viewDetails: '자세히 보기',
    lastUpdated: '최종 수정일',
  },
  profile: {
    title: '내 정보',
    email: '이메일',
    emailReadonly: 'Google 계정 이메일은 수정할 수 없습니다',
    name: '이름',
    namePlaceholder: '이름을 입력하세요',
    phone: '휴대폰 번호',
    phonePlaceholder: '010-1234-5678',
    company: '회사/소속',
    companyPlaceholder: '예: 네이버, 카카오, 스타트업명',
    domain: '도메인',
    domainPlaceholder: '예: 핀테크, 이커머스, 헬스케어',
    position: '포지션',
    positionPlaceholder: '예: QA 엔지니어, PM, 개발자',
    evaluationContext: '아래 정보는 릴리즈 평가 시 맥락 파악에 활용됩니다.',
    // GitHub 연동
    githubIntegrationTitle: 'GitHub 연동',
    githubNotConnectedDesc: 'GitHub 리포지토리를 읽기 위해 계정을 연결하세요.',
    githubConnectedAs: '연결됨: @{username}',
    githubConnect: 'GitHub 연결',
    githubConnectFailed: 'GitHub 연결에 실패했습니다',
    githubConnectConfirmTitle: 'GitHub 계정 연결',
    githubConnectConfirmDesc: 'GitHub OAuth는 현재 브라우저에 로그인된 GitHub 계정으로 바로 진행될 수 있어요.',
    githubConnectDifferentAccountHint: '다른 GitHub 계정으로 연결하려면: (1) GitHub에서 로그아웃 후 원하는 계정으로 로그인하거나, (2) 다른 브라우저 프로필/시크릿 창을 사용하세요.',
    githubUseCurrentAccount: '현재 GitHub 계정으로 계속',
    githubConnecting: '연결 중...',
    githubOpenLogoutPage: 'GitHub 로그아웃 페이지 열기',
    githubDisconnect: '연결 해제',
    githubDisconnecting: '해제 중...',
    githubDisconnectFailed: 'GitHub 연결 해제에 실패했습니다',
    githubLoading: '불러오는 중...',
    githubCommitReviewOpen: '커밋 변경 분석',
    // GitHub Organization 접근
    githubOrgAccessQuestion: 'Organization 레포가 안 보이나요?',
    githubOrgAccessSettings: 'GitHub 권한 설정 →',
    githubOrgAccessHint: '클릭 후 원하는 Organization을 Grant 하세요.',
    save: '저장',
    saving: '저장 중...',
    saveSuccess: '프로필이 저장되었습니다',
    saveFailed: '프로필 저장에 실패했습니다',
    profileImage: '프로필 이미지',
    uploadImage: '업로드',
    changeImage: '변경',
    deleteImage: '삭제',
    uploading: '업로드 중...',
    imageHint: 'JPEG, PNG, GIF, WebP (최대 5MB)',
    imageTypeError: '지원하지 않는 파일 형식입니다. (JPEG, PNG, GIF, WebP만 가능)',
    imageSizeError: '파일 크기는 5MB 이하여야 합니다.',
    imageUploadFailed: '이미지 업로드에 실패했습니다.',
    imageDeleteFailed: '이미지 삭제에 실패했습니다.',
    storageNotAvailable: '로컬 환경에서는 이미지 업로드가 지원되지 않습니다.',
    deleteAccount: '회원 탈퇴',
    deleteWarningTitle: '⚠️ 정말 탈퇴하시겠습니까?',
    deleteWarning: '탈퇴 시 서비스 이용을 즉시 중단하며, 평가 기록/팀 정보 등 서비스 데이터는 삭제됩니다. 단, 개인정보처리방침 및 관련 법령에 따라 일부 정보는 탈퇴 후 최대 1개월(결제 관련 기록은 5년)까지 보관 후 파기될 수 있습니다.',
    confirmDelete: '탈퇴하기',
    deleting: '탈퇴 처리 중...',
    deleteFailed: '탈퇴 처리에 실패했습니다',
    cancel: '취소',
    farewellTitle: '아쉬워요',
    farewellMessage: '계정 탈퇴가 완료되었습니다.\n그동안 이용해주셔서 감사합니다.',
    farewellSubMessage: '언제든 다시 돌아오시면 반갑게 맞이할게요.',
    farewellCta: '확인',
    farewellTogetherLine: '우리는 D+{days}일 동안 같이 했어요.',
    farewellSeeYouLine: '언젠가 다시 만나길 바랄게요.',
    leaveTeamFirstTitle: '👥 팀에 소속되어 있어요',
    leaveTeamFirstMessage: '회원 탈퇴를 진행하려면 먼저 소속 팀에서 나가야 합니다.',
    leaveTeamFirstHint: '프로필 > 팀 관리에서 팀을 나간 후 다시 시도해주세요.',
    understood: '확인',
    // 가입일 (함께한 날)
    memberSince: '함께한 날',
    daysTogether: '우리의 여정',
    daysTogetherUnit: '일째',
    milestone7: '🌱 새싹 동료',
    milestone30: '🌿 한 달 친구',
    milestone100: '🌳 100일 파트너',
    milestone365: '🎂 1주년 동지',
    milestone1000: '🏆 레전드 멤버',
    nextMilestone: '다음 마일스톤까지',
    daysRemaining: '{days}일 남음',
  },
  rating: {
    title: '서비스가 도움이 되셨나요?',
    subtitle: '10초만 투자해주세요! 여러분의 소중한 평가가 서비스 개선에 큰 힘이 됩니다 💪',
    starLabel: '점',
    rating1: '😢 많이 아쉬워요',
    rating2: '😕 조금 아쉬워요',
    rating3: '😐 보통이에요',
    rating4: '😊 좋아요!',
    rating5: '🤩 최고예요!',
    later: '다음에 할게요',
    neverAsk: '다시 묻지 않기',
    thankYouHigh: '감사합니다! 🎉',
    thankYouLow: '소중한 의견 감사합니다',
    feedbackPromptHigh: '더 좋은 서비스를 위해 한마디 남겨주시면 큰 힘이 됩니다!',
    feedbackPromptLow: '어떤 점을 개선하면 좋을까요? 의견을 들려주세요.',
    feedbackPlaceholder: '자유롭게 의견을 남겨주세요... (선택사항)',
    back: '뒤로',
    submit: '제출하기',
    submitting: '제출 중...',
    skipFeedback: '피드백 없이 별점만 제출',
    thankYouComplete: '피드백 감사합니다! 더 나은 서비스로 보답하겠습니다 ✨',
  },
  pricing: {
    title: '요금제',
    subtitle: '팀의 릴리즈 품질을 높이는 가장 합리적인 투자',
    viewPricing: '요금제 보기',
    // 플랜 상태
    currentPlanStatus: '현재 플랜 상태',
    currentPlan: '현재 플랜',
    beta: '베타',
    betaPeriod: '베타 기간',
    freeAccess: '무료 이용 중 🎉',
    started: '구독 시작일',
    nextBilling: '다음 결제일',
    expiresOn: '만료 예정일',
    afterBeta: '베타 종료 후 결정',
    subscriptionExpiresWarning: '구독이 {date}에 만료됩니다. 만료 후 {nextDate}부터 Free 플랜으로 전환됩니다.',
  },
  history: {
    title: '평가 히스토리',
    subtitle: '총 {count}건 (최대 {limit}건)',
    empty: '아직 평가 기록이 없습니다.',
    loadError: '히스토리를 불러오는데 실패했습니다.',
    retry: '다시 시도',
    detail: '평가 상세',
    reEvaluate: '이 데이터로 다시 평가하기',
    viewHistory: '히스토리',
  },
  team: {
    title: '팀 관리',
    createTeam: '팀 만들기',
    teamName: '팀 이름',
    teamNamePlaceholder: '예: QA팀, 프로덕트팀',
    create: '생성',
    creating: '생성 중...',
    members: '멤버',
    memberCount: '{count}명 / {max}명',
    pendingInvites: '대기 중인 초대',
    inviteMember: '팀원 초대',
    emailPlaceholder: '초대할 이메일 주소',
    roleManager: '매니저',
    roleMember: '멤버',
    roleOwner: '오너',
    roleLead: '오너(리드)',
    invite: '초대',
    inviting: '초대 중...',
    cancelInvite: '초대 취소',
    removeMember: '멤버 제거',
    changeRole: '역할 변경',
    leaveTeam: '팀 나가기',
    deleteTeam: '팀 삭제',
    noTeam: '소속된 팀이 없습니다',
    noTeamDesc: '팀을 만들거나 초대를 받아 팀에 참여하세요.',
    teamRequired: 'Team 플랜 필요',
    teamRequiredDesc: '팀 기능은 Team 플랜에서만 사용할 수 있습니다.',
    maxMembers: '최대 {max}명',
    expires: '{days}일 후 만료',
    expired: '만료됨',
    inviteSent: '초대가 발송되었습니다',
    memberRemoved: '멤버가 제거되었습니다',
    inviteCancelled: '초대가 취소되었습니다',
    roleChanged: '역할이 변경되었습니다',
    leftTeam: '팀에서 나왔습니다',
    teamDeleted: '팀이 삭제되었습니다',
    confirmRemove: '이 멤버를 팀에서 제거하시겠습니까?',
    confirmLeave: '정말 팀을 나가시겠습니까?',
    confirmDelete: '팀 삭제',
    confirmDeleteDesc: '팀을 삭제하면 모든 멤버의 팀 연결이 해제됩니다. 이 작업은 되돌릴 수 없습니다.',
    cancel: '취소',
    confirm: '확인',
    viewTeam: '팀 관리',
    // 리드 양도
    transferOwnership: '리드 양도',
    transferOwnershipDesc: '다른 팀원에게 리드(오너) 권한을 양도합니다. 양도 후 본인은 매니저가 됩니다.',
    transferTo: '양도 대상 선택',
    confirmTransfer: '리드 양도 확인',
    confirmTransferDesc: '정말 {name}님에게 리드 권한을 양도하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
    ownershipTransferred: '리드 권한이 양도되었습니다',
    // 추가 좌석
    addSeats: '좌석 추가 구매',
    addSeatsDesc: '팀 멤버 수를 늘리려면 추가 좌석을 구매하세요.',
    seatsPerPurchase: '5석 추가',
    maxSeatsReached: '최대 좌석 수에 도달했습니다 (50명)',
    purchaseSeats: '좌석 구매하기',
    purchasing: '결제 페이지 이동 중...',
  },
  apiKeys: {
    title: 'API 키 관리',
    subtitle: 'API를 통해 릴리즈 평가를 자동화하세요',
    createKey: '새 API 키 생성',
    keyName: '키 이름',
    keyNamePlaceholder: '예: Production, Development',
    create: '생성',
    creating: '생성 중...',
    noKeys: '발급된 API 키가 없습니다',
    noKeysDesc: 'API 키를 생성하여 릴리즈 평가 API를 사용하세요.',
    teamRequired: 'Team 플랜 필요',
    teamRequiredDesc: 'API 키는 Team 플랜에서만 사용할 수 있습니다.',
    keyCreated: 'API 키가 생성되었습니다!',
    keyCreatedWarning: '이 키는 다시 표시되지 않습니다. 지금 복사해두세요.',
    copyKey: '복사',
    copied: '복사됨!',
    dailyUsage: '일일 사용량',
    lastUsed: '마지막 사용',
    never: '사용 기록 없음',
    revokeKey: '폐기',
    confirmRevoke: '이 API 키를 폐기하시겠습니까? 폐기된 키는 다시 사용할 수 없습니다.',
    keyRevoked: 'API 키가 폐기되었습니다',
    maxKeysReached: '최대 {max}개의 API 키까지 생성할 수 있습니다',
    viewApiKeys: 'API 키',
    apiDocumentation: 'API 문서 보기',
    memberViewOnly: 'API 키는 팀 오너만 생성할 수 있습니다. 생성된 키를 확인할 수 있습니다.',
    usageGuide: 'API 사용 가이드',
    usageGuideDesc: 'API 키 사용 방법 및 엔드포인트 정보를 확인하세요.',
  },
  downgrade: {
    // 공통
    planExpired: '구독이 만료되었습니다',
    planDowngraded: '플랜이 변경되었습니다',
    upgradeToAccess: '이 기능을 사용하려면 플랜을 업그레이드하세요',
    upgradePlan: '플랜 업그레이드',
    // 팀 기능
    teamFrozen: '팀 기능이 비활성화되었습니다',
    teamFrozenDesc: '팀 오너의 Team 구독이 만료되어 팀 기능이 일시 중지되었습니다.',
    teamFrozenOwnerDesc: 'Team 플랜을 갱신하면 팀 기능을 다시 사용할 수 있습니다.',
    teamDataPreserved: '팀 데이터는 안전하게 보관됩니다',
    teamMembersAffected: '팀원 {count}명이 영향을 받습니다',
    // API 키
    apiKeysFrozen: 'API 키가 비활성화되었습니다',
    apiKeysFrozenDesc: 'Team 플랜 구독이 만료되어 API 키 사용이 중지되었습니다.',
    apiKeysDataPreserved: '발급된 키는 보관되며, 재구독 시 다시 사용할 수 있습니다',
    // 히스토리
    historyReadOnly: '히스토리 읽기 전용',
    historyReadOnlyDesc: '현재 플랜에서는 새로운 평가가 히스토리에 저장되지 않습니다.',
    historyLimitReached: '히스토리 저장 한도에 도달했습니다',
    // 기능 제한
    featureLocked: '이 기능은 현재 플랜에서 사용할 수 없습니다',
    pdfLocked: 'PDF 다운로드는 Pro 이상 플랜에서 사용할 수 있습니다',
    // 쿼터
    quotaExceeded: '월간 평가 한도를 초과했습니다',
    quotaResetDate: '{date}에 리셋됩니다',
  },
  dashboard: {
    title: '대시보드',
    subtitle: '플랜 정보 및 사용량 현황',
    backToHome: '← 홈으로',
    currentPlan: '현재 플랜',
    planFeatures: '플랜 기능',
    usage: '사용량',
    monthlyEvaluations: '월간 평가',
    unlimited: '무제한',
    remaining: '남음',
    used: '사용',
    limits: '제한',
    testCasesPerEval: '평가당 테스트케이스',
    planningChars: 'Planning 글자 수',
    historyStorage: '히스토리 저장',
    pdfDownload: 'PDF 다운로드',
    apiAccess: 'API 액세스',
    teamFeature: '팀 기능',
    available: '가능',
    notAvailable: '사용 불가',
    items: '개',
    chars: '자',
    upgradePrompt: '더 많은 기능을 원하시나요?',
    upgradeCta: '플랜 업그레이드',
    teamInfo: '팀 정보',
    teamName: '팀 이름',
    teamRole: '역할',
    teamMembers: '팀원 수',
    // 트렌드 & 대시보드
    personalTrend: '개인 트렌드',
    teamTrend: '팀 트렌드',
    teamDashboard: '팀 대시보드',
    teamDashboardTitle: '팀 대시보드',
    teamDashboardDesc: '팀 전체의 릴리즈 품질 현황을 한눈에 확인하세요',
    viewTeamDashboard: '팀 대시보드 보기',
    teamDashboardRequireTeam: 'Team 플랜에서만 사용할 수 있습니다',
    teamMemberStats: '팀원별 통계',
    teamTrendAnalysis: '팀 트렌드 분석',
  },
  demo: {
    title: '데모 모드',
    viewResult: '> 데모 결과 보기',
    loginPrompt: '로그인하면 직접 입력하여 AI 평가를 받을 수 있습니다',
    resultBanner: '데모 결과',
    resultDescription: '로그인하면 직접 입력한 데이터로 AI 평가를 받을 수 있습니다',
  },
  statistics: {
    title: '평가 통계',
    subtitle: '최근 {days}일간 데이터',
    description: '일별 평가 추이와 상태별 분포를 확인하세요',
    viewButton: '자세히 보기',
    loadError: '통계를 불러오는데 실패했습니다',
    totalEvaluations: '총 평가',
    avgScore: '평균 점수',
    dailyTrend: '일별 평가 추이',
    statusDistribution: '상태별 분포',
    noData: '데이터 없음',
    periodDays: '기간',
  },
  errorPage: {
    goHome: '홈으로',
    retry: '다시 시도',
    viewPricing: '요금제 보기',
    supportContact: '문제가 지속되면 {email}로 문의해주세요.',
    401: {
      title: '로그인이 필요합니다',
      description: '이 작업을 계속하려면 먼저 로그인해야 합니다.',
      hint: '로그인 후 다시 시도해주세요. (토큰이 만료된 경우도 동일하게 발생할 수 있습니다)',
    },
    402: {
      title: '결제가 필요합니다',
      description: '이 기능을 사용하려면 유료 플랜 구독이 필요합니다.',
      hint: '현재 무료 체험 기간이 만료되었거나, 결제 정보에 문제가 있을 수 있습니다.',
    },
    404: {
      title: '페이지를 찾을 수 없습니다',
      description: '요청하신 페이지가 존재하지 않거나 이동되었습니다.',
      hint: 'URL이 올바른지 확인하거나, 홈에서 다시 시작해보세요.',
    },
    429: {
      title: '요청이 너무 많습니다',
      description: '짧은 시간에 너무 많은 요청을 보내셨습니다. 잠시 후 다시 시도해주세요.',
      hint: 'API 사용량 제한에 도달했습니다. 몇 분 후 다시 시도하거나 플랜 업그레이드를 고려해보세요.',
    },
    500: {
      title: '서버 오류가 발생했습니다',
      description: '죄송합니다. 서버에서 예상치 못한 오류가 발생했습니다.',
      hint: '잠시 후 다시 시도해주세요. 문제가 계속되면 고객지원에 문의해주세요.',
    },
    505: {
      title: '지원하지 않는 요청입니다',
      description: '요청하신 HTTP 버전 또는 프로토콜을 지원하지 않습니다.',
      hint: '브라우저를 최신 버전으로 업데이트하거나, 다른 브라우저를 사용해보세요.',
    },
  },
  welcome: {
    title: 'ReleaseGate에 오신 것을 환영합니다!',
    subtitle: 'AI 기반 릴리즈 판단 도구로 출시 결정의 불확실성을 줄여보세요.',
    question: '어떻게 사용하실 건가요?',
    individual: '개인으로 사용할게요',
    individualDesc: '개인 프로젝트나 혼자 QA 업무를 하시는 분',
    team: '팀으로 사용할게요',
    teamDesc: '팀원들과 함께 릴리즈 판단을 공유하고 싶으신 분',
    justBrowse: '일단 구경만 할게요 →',
    back: '뒤로',
    selectPlan: '플랜을 선택해주세요',
    betaBenefit: '베타 기간 혜택',
    betaBenefitDesc: '현재 베타 기간 동안 모든 기능을 무료로 이용할 수 있습니다!',
    decideLater: '나중에 결정할게요, 일단 구경만 할래요',
    getStarted: '시작하기',
    processing: '처리 중...',
    forTeams: '팀을 위한 선택',
    popular: '추천',
    individualPlans: '개인 플랜',
    teamPlan: '팀 플랜',
  },
  suggestedTestcases: {
    title: 'AI 제안 체크리스트',
    subtitle: '기획 의도, 리스크, 커밋을 기반으로 AI가 릴리즈 전 확인 체크리스트를 제안합니다',
    generateButton: '체크리스트 생성',
    generating: '체크리스트 생성 중...',
    regenerate: '다시 생성',
    clear: '초기화',
    coreCategory: '핵심',
    edgeCategory: '엣지',
    priorityHigh: '높음',
    priorityMedium: '중간',
    priorityLow: '낮음',
    statusPass: 'Pass',
    statusFail: 'Fail',
    statusNA: 'N/A',
    statusNT: 'N/T',
    selectStatus: '상태 선택',
    source: '출처',
    sourceRisk: '리스크',
    sourcePlanning: '기획',
    sourceCommit: '커밋',
    noTestcases: '생성된 체크리스트가 없습니다',
    generateHint: '기획 의도, 리스크 또는 GitHub 커밋을 입력한 후 체크리스트를 생성해보세요',
    summary: '요약',
    passCount: '통과',
    failCount: '실패',
    naCount: '해당없음',
    ntCount: '미확인',
    addMemo: '메모 추가',
    hideMemo: '메모 숨기기',
    memoPlaceholder: '확인 결과에 대한 메모를 작성하세요...',
    memo: '메모',
    // 담당자
    author: '작성자',
    tester: '진행자',
    modifier: '수정자',
    authorPlaceholder: '작성자 이름',
    testerPlaceholder: '진행자 이름',
    modifiedAt: '수정됨',
    assignees: '담당자',
    hideAssignees: '취소',
    editHistory: '수정 이력',
    before: '변경 전',
    after: '변경 후',
    // 플랜 제한
    aiGenerateLocked: 'AI 체크리스트 생성',
    aiGenerateMaxTeamOnly: 'Max/Team 플랜 전용 기능',
    aiGenerateProRegister: 'Pro 플랜은 등록 후 사용 가능',
    aiGenerateFreeLocked: '업그레이드 후 사용 가능',
    registerToUse: '등록하기',
    upgradePlan: '플랜 업그레이드',
  },
  
  autoLogout: {
    title: '세션 만료 경고',
    description: '오랜 시간 활동이 없어 곧 자동 로그아웃됩니다.',
    remaining: '남은 시간',
    extend: '계속 사용하기',
    logoutNow: '로그아웃',
    hint: '보안을 위해 30분간 활동이 없으면 자동으로 로그아웃됩니다.',
    loggedOutTitle: '자동 로그아웃되었습니다',
    loggedOutDescription: '보안을 위해 자동으로 로그아웃되었습니다. 계속 사용하시려면 다시 로그인해주세요.',
    loginAgain: '다시 로그인',
    closeModal: '닫기',
  },

  home: {
    // 로그인 사용자 홈
    startEvaluation: '릴리즈 평가',
    quickActions: '빠른 작업',
    recentActivity: '최근 활동',
    noRecentActivity: '아직 평가 기록이 없어요',
    viewAllHistory: '전체 히스토리 보기',
    // 비로그인 랜딩
    heroTitle: 'AI가 판단하는\n릴리즈 Go/No-Go',
    heroSubtitle: '기획 의도, 리스크, QA 결과를 입력하면\nAI가 릴리즈 가능 여부를 판단해드려요',
    tryDemo: '데모 체험하기',
    signUpFree: '무료로 시작하기',
    feature1Title: '3단계 검증',
    feature1Desc: '기획 → 리스크 → 테스트 순차 검증',
    feature2Title: 'AI 분석',
    feature2Desc: '맥락을 이해하는 정밀한 평가',
    feature3Title: '팀 협업',
    feature3Desc: '팀 전체 릴리즈 품질 대시보드',
    trustedByOptions: [
      'QA 팀을 위해 만들었어요',
      '지금 바로 시작해보세요',
      '새로운 릴리즈 검증을 경험하세요',
    ],
    // 함께한 날
    daysTogether: '함께한 날',
    daysTogetherSuffix: '일째',
    // 배지
    badges: '획득한 배지',
    badgeNewbie: '🌱 새싹',
    badgeExplorer: '🔍 탐험가',
    badgeRegular: '⭐ 단골',
    badgeVeteran: '🏅 베테랑',
    badgeLegend: '🏆 레전드',
    noBadges: '아직 배지가 없어요',
    badgeUnlocked: '배지 획득!',
    // 퀵 스탯
    totalEvaluations: '누적 기록',
    thisMonth: '이번 달 기록',
    avgScore: '평균 점수',
  },

  testcaseManager: {
    title: '테스트케이스 관리',
    subtitle: '팀의 테스트케이스를 생성하고 관리하세요',
    createNew: '새 테스트케이스',
    importFile: '파일 가져오기',
    searchPlaceholder: '테스트케이스 검색...',
    filterAll: '전체',
    filterActive: '활성',
    filterArchived: '보관됨',
    sortNewest: '최신순',
    sortOldest: '오래된순',
    sortName: '이름순',
    noTestcases: '테스트케이스가 없습니다',
    noTestcasesDesc: '새 테스트케이스를 만들거나 파일을 가져와보세요',
    // 테스트케이스 항목
    category: '카테고리',
    priority: '우선순위',
    status: '상태',
    lastUpdated: '마지막 수정',
    createdAt: '생성일',
    description: '설명',
    expectedResult: '예상 결과',
    actualResult: '실제 결과',
    // 액션
    edit: '편집',
    delete: '삭제',
    duplicate: '복제',
    archive: '보관',
    restore: '복원',
    useInEvaluation: '평가에 사용',
    // 생성/편집 폼
    createTitle: '새 테스트케이스 만들기',
    editTitle: '테스트케이스 편집',
    titleLabel: '제목',
    titlePlaceholder: '테스트케이스 제목을 입력하세요',
    descriptionPlaceholder: '테스트 시나리오를 설명하세요...',
    expectedResultPlaceholder: '예상되는 결과를 입력하세요...',
    save: '저장',
    saving: '저장 중...',
    cancel: '취소',
    // 카테고리
    categoryCore: '핵심',
    categoryEdge: '엣지',
    categoryRegression: '회귀',
    categorySmoke: '스모크',
    // 상태
    statusDraft: '초안',
    statusActive: '활성',
    statusPassed: '통과',
    statusFailed: '실패',
    statusSkipped: '건너뜀',
    // 목업 안내
    mockupTitle: '🚧 개발 예정 기능',
    mockupDesc: '테스트케이스 관리 기능은 곧 출시됩니다!\n아래는 기능 미리보기입니다.',
    comingSoon: 'Coming Soon',
  },

  flowGenerator: {
    title: '🔄 Flow Testcase Generator',
    subtitle: '화면 흐름 기반 테스트케이스 자동 생성',
    description: '화면 목록과 전환 관계를 입력하면 screens, transitions, assertions, contexts, testcases CSV를 자동으로 생성합니다.',
    // 탭
    inputTab: '입력',
    previewTab: '미리보기',
    downloadTab: '다운로드',
    // 화면 입력
    screensTitle: '화면 목록',
    addScreen: '화면 추가',
    screenId: '화면 ID',
    screenName: '화면 이름',
    isMenu: '메뉴',
    // 전환 관계
    transitionsTitle: '전환 관계',
    addTransition: '전환 추가',
    fromScreen: '출발 화면',
    toScreen: '도착 화면',
    triggerLabel: '트리거 (버튼/링크)',
    // 옵션
    optionsTitle: '옵션',
    testidPrefix: 'data-testid 접두사',
    autoGenerateTestids: 'testid 자동 생성',
    autoGenerateAssertions: 'assertions 자동 생성',
    // 액션
    generateCSV: 'CSV 생성하기',
    generating: '생성 중...',
    downloadZip: 'ZIP 다운로드',
    downloading: '다운로드 중...',
    importJSON: 'JSON 가져오기',
    exportJSON: 'JSON 내보내기',
    // 통계
    statsTitle: '통계',
    totalScreens: '화면',
    totalTransitions: '전환',
    totalTestcases: '테스트케이스',
    // 경고/에러
    warningsTitle: '경고',
    noScreensError: '최소 1개의 화면을 입력해주세요.',
    noTransitionsError: '최소 1개의 전환을 입력해주세요.',
    needTwoScreens: '전환을 추가하려면 최소 2개의 화면이 필요합니다.',
  },

  releaseTarget: {
    title: '평가 대상',
    frontend: 'Frontend',
    frontendDesc: '웹/모바일 UI',
    backend: 'Backend',
    backendDesc: 'API/서비스',
    fullstack: 'Fullstack',
    fullstackDesc: '프론트+백',
    infra: 'Infra',
    infraDesc: '인프라/DevOps',
    automation: 'Automation',
    automationDesc: '자동화/봇',
  },

  backendChecks: {
    title: '백엔드 체크리스트',
    subtitle: '백엔드 릴리즈를 위한 필수 체크 항목입니다',
    // API 계약
    apiContract: 'API 계약/문서화',
    apiContractDesc: 'API 스키마 및 계약 변경사항',
    schemaChanged: '스키마 변경 (OpenAPI/Response)',
    breakingChange: 'Breaking Change (필드 제거/타입 변경)',
    versionStrategy: '버전 전략',
    versionStrategyPlaceholder: '예: v1 → v2, deprecate 기간 3개월',
    errorModelDefined: '에러 모델 정의됨',
    // 인증/보안
    authSecurity: '인증/보안',
    authSecurityDesc: '인증, 인가, 보안 관련 체크',
    authChanged: '인증/인가 변경 (JWT, API Key, scope)',
    rateLimitConfigured: 'Rate Limit 설정됨',
    abuseProtection: 'Abuse 방어 적용됨',
    piiLoggingSafe: 'PII 로그 마스킹됨',
    // DB/마이그레이션
    dbMigration: 'DB/마이그레이션',
    dbMigrationDesc: '데이터베이스 및 마이그레이션 체크',
    migrationExists: '마이그레이션 스크립트 존재',
    rollbackPossible: '롤백 가능',
    backwardCompatible: '기존 버전과 호환',
    indexPerformanceChecked: '인덱스/쿼리 성능 확인됨',
    // 신뢰성
    reliability: '신뢰성',
    reliabilityDesc: '장애 대응 및 안정성 체크',
    timeoutConfigured: '타임아웃 설정됨',
    retryLogic: '재시도 로직 있음',
    circuitBreaker: '서킷브레이커 적용됨',
    externalDependencyFallback: '외부 의존성 장애 시 동작',
    externalDependencyFallbackPlaceholder: '예: Redis 다운 시 로컬 캐시 사용',
    // 관측성
    observability: '관측성',
    observabilityDesc: '모니터링 및 알람 체크',
    loggingReady: '로깅 준비됨',
    metricsReady: '메트릭 준비됨',
    tracingReady: '트레이싱 준비됨',
    alertingConfigured: '알람 설정됨',
    sentryIntegrated: 'Sentry 연동됨',
    // 성능
    performance: '성능',
    performanceDesc: '성능 목표 및 테스트',
    p95TargetMs: 'p95 목표 (ms)',
    p99TargetMs: 'p99 목표 (ms)',
    loadCondition: '부하 조건',
    loadConditionPlaceholder: '예: 동시 100명, 초당 1000 요청',
    loadTestResult: '부하 테스트 결과',
    loadTestResultPlaceholder: '예: p95 120ms, 에러율 0.01%',
    // 공통
    yes: '예',
    no: '아니오',
    notSet: '미설정',
  },

  // 환경설정
  settings: {
    title: '환경설정',
    // 탭
    accountLinking: '계정 연동',
    accountManagement: '계정 관리',
    security: '보안',
    display: '표시 설정',
    mfa: 'MFA',
    notifications: '알림',
    termsTab: '약관 보기',
    // 계정 연동
    googleAccount: 'Google 계정',
    githubAccount: 'GitHub 계정',
    connected: '연결됨',
    notConnected: '연결 안 됨',
    connect: '연결',
    disconnect: '연결 해제',
    connecting: '연결 중...',
    disconnecting: '해제 중...',
    connectFailed: '연결에 실패했습니다',
    disconnectFailed: '연결 해제에 실패했습니다',
    // 계정 관리
    deleteAccount: '회원 탈퇴',
    deleteAccountDesc: '계정을 삭제하면 모든 데이터가 영구적으로 삭제되며 복구할 수 없습니다.',
    deleteAccountButton: '탈퇴하기',
    changePassword: '비밀번호 변경',
    changePasswordDesc: '계정 보안을 위해 주기적으로 비밀번호를 변경하세요.',
    changePasswordButton: '비밀번호 변경',
    currentPassword: '현재 비밀번호',
    newPassword: '새 비밀번호',
    confirmPassword: '비밀번호 확인',
    passwordChanged: '비밀번호가 변경되었습니다.',
    passwordChangeFailed: '비밀번호 변경에 실패했습니다.',
    passwordMismatch: '새 비밀번호가 일치하지 않습니다.',
    // 보안
    loginHistory: '로그인 기록',
    loginHistoryDesc: '최근 로그인 활동을 확인할 수 있습니다.',
    activeSessions: '활성 세션',
    activeSessionsDesc: '현재 로그인된 기기들을 관리할 수 있습니다.',
    currentSession: '현재 세션',
    logoutAllSessions: '모든 세션 로그아웃',
    noLoginHistory: '로그인 기록이 없습니다.',
    device: '기기',
    location: '위치',
    lastAccess: '마지막 접속',
    securityComingSoon: '보안 기능은 준비 중입니다.',
    // 표시 설정
    languageSetting: '언어',
    languageSettingDesc: '인터페이스 언어를 선택하세요.',
    themeSetting: '테마',
    themeSettingDesc: '화면 테마를 선택하세요.',
    themeLight: '라이트',
    themeDark: '다크',
    themeSystem: '시스템 설정',
    timezoneSetting: '시간대',
    timezoneSettingDesc: '날짜와 시간 표시에 사용할 시간대를 선택하세요.',
    timezoneAuto: '자동 (브라우저 설정)',
    // MFA
    mfaTitle: 'MFA 활성화',
    mfaDescription: '다중 인증(MFA)을 활성화하면 계정 보안이 강화됩니다.',
    mfaEnabled: 'MFA 활성화',
    emailOtp: '이메일 OTP',
    emailOtpDesc: '로그인 시 이메일로 인증 코드를 받습니다.',
    smsOtp: 'SMS OTP',
    smsOtpDesc: '로그인 시 휴대폰 문자로 인증 코드를 받습니다.',
    smsOtpDisabled: '준비 중',
    totp: 'TOTP 인증 앱',
    totpDesc: '인증 앱에서 생성한 코드로 인증합니다.',
    totpApps: 'Google Authenticator, Authy 등',
    totpDisabled: '준비 중',
    // 알림
    notificationsNotImplemented: '알림 설정은 준비 중입니다.',
    emailNotifications: '이메일 알림',
    emailNotificationsDesc: '받고 싶은 이메일 알림을 선택하세요.',
    notifyEvaluation: '평가 완료 알림',
    notifyEvaluationDesc: 'Go/No-Go 평가 결과를 이메일로 받습니다.',
    notifyTeamInvite: '팀 초대 알림',
    notifyTeamInviteDesc: '팀 초대를 받았을 때 이메일로 알려드립니다.',
    notifyTeamActivity: '팀 활동 알림',
    notifyTeamActivityDesc: '팀원이 평가를 완료했을 때 알려드립니다.',
    notifySubscription: '구독 알림',
    notifySubscriptionDesc: '결제 실패, 갱신 예정, 플랜 변경 안내를 받습니다.',
    notifySecurity: '보안 알림',
    notifySecurityDesc: '새 기기 로그인, 비밀번호 변경 시 알려드립니다.',
    notifyNewsletter: '뉴스레터',
    notifyNewsletterDesc: '소프트웨어 뉴스를 아침/점심/저녁에 받습니다.',
    notifyProductUpdate: '제품 업데이트',
    notifyProductUpdateDesc: '새 기능, 개선사항 안내를 받습니다.',
    // 약관
    termsTitle: '약관 동의 현황',
    termsDescription: '현재 동의한 약관 및 정책을 확인하고 관리할 수 있습니다.',
    termsOfService: '이용약관',
    termsOfServiceDesc: '서비스 이용에 필요한 필수 약관입니다.',
    privacyPolicy: '개인정보처리방침',
    privacyPolicyDesc: '개인정보 수집 및 이용에 대한 필수 동의입니다.',
    marketingConsent: '마케팅 정보 수신',
    marketingConsentDesc: '이벤트, 혜택 등 마케팅 정보를 받아보실 수 있습니다.',
    required: '필수',
    optional: '선택',
    agreed: '동의함',
    withdrawn: '동의 안 함',
    termsAgreedToast: '이용약관에 동의하였습니다.',
    termsWithdrawnToast: '이용약관 동의를 철회하였습니다.',
    privacyAgreedToast: '개인정보처리방침에 동의하였습니다.',
    privacyWithdrawnToast: '개인정보처리방침 동의를 철회하였습니다.',
    marketingAgreedToast: '마케팅 정보 수신에 동의하였습니다.',
    marketingWithdrawnToast: '마케팅 정보 수신 동의를 철회하였습니다.',
    // 버튼
    cancel: '취소',
    save: '저장',
    saving: '저장 중...',
  },

  criteria: {
    title: '릴리즈 판정 기준 설정',
    description: 'Go/Conditional/Holding/No-Go 판정 기준을 커스터마이즈하세요.',
    scoreThresholds: '점수 임계값',
    goThreshold: 'GO 최소 점수',
    conditionalThreshold: 'Conditional 최소 점수',
    holdingThreshold: 'Holding 최소 점수',
    belowHolding: '위 점수 미만은 No-Go',
    blockerRules: '블로커 규칙',
    blockerDescription: '체크된 항목이 요구사항에 포함되어 있지만 관련 예외/리스크 처리가 언급되지 않으면 No-Go로 판정됩니다.',
    customBlockers: '커스텀 블로커',
    addCustomBlocker: '커스텀 블로커 추가',
    keywordPlaceholder: '키워드 (예: HIPAA)',
    messagePlaceholder: '블로커 메시지 (예: HIPAA 규정 미준수)',
    additionalRules: '추가 규칙',
    testFailDowngrade: '테스트 실패 시 다운그레이드',
    testFailDowngradeDesc: '테스트케이스 실패가 있으면 GO → Conditional로 다운그레이드',
    nfrMissingHolding: 'NFR 누락 시 Holding',
    nfrMissingHoldingDesc: '비기능 요구사항이 없으면 무조건 Holding 처리',
    acZeroNogo: 'AC 0점 시 No-Go',
    acZeroNogoDesc: 'Acceptance Criteria 점수가 0점이면 무조건 No-Go 처리',
    domainSelection: '도메인 선택',
    domainDescription: '도메인을 선택하면 적합한 기준을 추천받을 수 있습니다.',
    getRecommendation: 'AI 추천 받기',
    applyRecommendation: '추천 적용',
    recommendationReason: '추천 이유',
    save: '저장',
    reset: '기본값으로 초기화',
    resetConfirm: '설정을 기본값으로 초기화하시겠습니까?',
    saveSuccess: '릴리즈 판정 기준이 저장되었습니다.',
    resetSuccess: '기본값으로 초기화되었습니다.',
    validationError: '점수 임계값은 GO > Conditional > Holding 순서여야 합니다.',
    domains: {
      fintech: '핀테크/금융',
      ecommerce: '이커머스',
      healthcare: '헬스케어/의료',
      social: '소셜/커뮤니티',
      saas: 'B2B SaaS',
      gaming: '게임',
      media: '미디어/콘텐츠',
      education: '교육/교육 컨텐츠',
      other: '기타',
    },
    blockers: {
      payment: '결제',
      personal_info: '개인정보',
      auth: '인증',
      webhook: '웹훅',
      delete: '삭제',
    },
  },
};

